<template>
  <div class="back-container">
    <v-scale-transition>
      <v-chip color="primary" dark class="btn-chip" v-if="event && isMyClient"  @click.stop="goToAppointment" v-show="showButton">
        <v-avatar >
          <img :src="user.avatar || getFakeAvatar(user.gender)" />
        </v-avatar>
        Volver a la cita con {{user.first_name}}
        <v-icon right @click.stop="hide">close</v-icon>
      </v-chip>
    </v-scale-transition>

  </div>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import {getFakeAvatar} from "@/utils/Common";

export default {
  name: "BackToAppointmentBtn",
  data(){
    return {
      visible: false
    }
  },
  computed:{
    ...mapState(['showBackToEvent', 'backToEvent']),
    event(){
      const vm = this
      return vm.backToEvent
    },
    isMyClient(){
      const vm = this

      if(!vm.currentUser) return false

      return vm.event
      && vm.event.schedule
      && vm.event.schedule.specialist
      && vm.event.schedule.specialist.id === vm.currentUser.id
    },
    user(){
      const vm = this
      return vm.event && vm.event.client || null
    },
    showButton(){
      const vm = this
      if(vm.$route.name === 'panel.provider.specialist_daily_schedule') return false

      return vm.showBackToEvent

    }
  },
  methods:{
    ...mapMutations([
      'setBackToEvent'
    ]),
    ...mapMutations('clientAttention', ['setEvent']),
    getFakeAvatar,
    hide(){
      const vm = this
      vm.setBackToEvent({
        show: false
      })
    },
    goToAppointment(){
      const vm = this
      const event = JSON.parse(JSON.stringify(vm.backToEvent))
      vm.hide()
      setTimeout(function(){
        vm.setEvent(event)
      }, 300)
      vm.$router.push({
        name: 'panel.provider.specialist_daily_schedule',
      })

    },
  }
}
</script>

<style scoped>

  .back-container{
    font-family: Roboto, sans-serif;
    z-index: 10;
    position: fixed;
    top: 75px;
    right: 10px;
    height: 40px;
  }

  .btn-chip{
    cursor: pointer !important;
    box-shadow: 3px 5px 20px rgba(0,0,0, 0.3);
  }

</style>
